import { RouteName } from "../RouteNames";

export const parliamentaryOverviewRoutes = {
  name: RouteName.ParliamentaryOverview,
  path: "/parliamentary-overview",
  component: () =>
    import("@follaw-fr/views/side_menu_views/ParliamentaryOverviewView.vue"),
};
